<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'SEARCH_CUSTOMERS' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding" [formGroup]="searchCustomersForm">
    <!-- First Row -->
    <div class="searchInputRow">
        <div class="inputContainer">
            <label class="inputLabel">{{'SALESFORCE_ID' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="salesForceId">
            </mat-form-field>
        </div>
        <div class="inputContainer">
            <label class="inputLabel">{{'CITY' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="city">
            </mat-form-field>
        </div>
    </div>

    <!-- Second Row -->
    <div class="searchInputRow">
        <div class="inputContainer">
            <label class="inputLabel">{{'SAP_NUMBER' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="sapNumber">
            </mat-form-field>
        </div>
        <div class="inputContainer">
            <label class="inputLabel">{{'STATE' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="state">
            </mat-form-field>
        </div>
        
    </div>

    <!-- Third Row -->
    <div class="searchInputRow">
        <div class="inputContainer">
            <label class="inputLabel">{{'NAME' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="name">
            </mat-form-field>
        </div>
        <div class="inputContainer">
            <label class="inputLabel">{{'ZIP_CODE' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="zipCode">
            </mat-form-field>
        </div>
    </div>
    <!-- Fourth Row -->
    <div class="searchInputRow">
        <div class="inputContainer">
            <label class="inputLabel">{{'ADDRESS_1' | translate}}:</label>
            <mat-form-field appearance="outline" class="inputFormField">
                <input matInput formControlName="address1">
            </mat-form-field>
        </div>
        <div class="inputContainer"></div>
    </div>

    <!-- Search Button -->
    <div class="mt-1">
        <button mat-raised-button color="primary" (click)="searchCustomers()">{{'SEARCH' | translate}}</button>
    </div>

    <!-- Results Area -->
    <div class="search-table">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)"
            class="full-width table table-bordered mat-elevation-z8">
            
            <ng-container matColumnDef="salesForceId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'SALESFORCE_ID' | translate }} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.salesForceId}} </td>
            </ng-container>
            
            <ng-container matColumnDef="sapNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'SAP_NO' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.sapNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="customerName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CUSTOMER_NAME' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.customerName}} </td>
            </ng-container>
            
            <ng-container matColumnDef="address1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'ADDRESS_1' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.address1}} </td>
            </ng-container>
            
            <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'CITY' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.city}} </td>
            </ng-container>
            
            <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'STATE' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.state}} </td>
            </ng-container>
            
            <ng-container matColumnDef="zipCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header > {{ 'ZIP_CODE' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="table-data">
                    {{element.zipCode}} </td>
            </ng-container>
    
            <!-- Header row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="row-height row-header" ></tr>
            <!-- Data rows -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-height"
                (dblclick)="onDblClick(row)"
                [class.selected]="selectedRow?.salesForceId === row?.salesForceId" (click)="onRowClick(row)">
            </tr>
    
            <!-- Row shown when there is no matching data -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data text-center" [attr.colspan]="displayedColumns.length">{{
                    'COMMON_LABELS.NO_DATA_FOUND' | translate }}</td>
            </tr>
        </table>
    </div>
    @if (totalCount > 0) {
        <div class="col-sm-12 row mat-paginator-sticky paginationDiv">
            <div class="col-sm-3 pt-3">
                <div class="goToTextBox">
                    <input type="number" min="1" [max]="totalPages" class="form-control form-control-sm"
                        [(ngModel)]="gotoPageNumber" [ngModelOptions]="{standalone: true}" (keyup.enter)="gotoPage()"
                        placeholder="{{'GOTO' | translate}}">
                </div>
                <div>
                    <p class="currentTotalLable">
                        {{'COMMON_LABELS.PAGES' | translate}}: {{currentPageNumber}} {{'COMMON_LABELS.OF' | translate}} {{totalPages}}
                    </p>
                </div>
            </div>
            <div class="col-sm-9 currentTotalLable">
                <mat-paginator
                    [length]="totalCount"
                    [pageSize]="pageSize"
                    [pageIndex]="currentPageNumber - 1"
                    [showFirstLastButtons]="true"
                    [hidePageSize]="true"
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions align="end" class="actionsPadding">
    <button class="openCloseBtn" mat-raised-button color="primary" >{{ 'HELP' | translate }}</button>
    <button class="openCloseBtn" mat-raised-button color="primary" (click)="resetForm()">{{ 'RESET' | translate }}</button>
    <button class="openCloseBtn" mat-raised-button color="primary" (click)="selectCustomer()" [disabled]="!selectedRow">{{ 'SELECT' | translate }}</button>
    <button class="openCloseBtn" mat-raised-button color="warn" mat-dialog-close>{{'CANCEL' | translate}}</button>
</mat-dialog-actions>